
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';



import i18n from "i18next";
import {initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: {
          "title": "English Buddy",
          "Choose a category:": "Choose a category:",
          "Learn ABC" : "Learn ABC",
          "Question" : "Question",
          "Submit"  :"Submit", 
          'Great Job!' : 'Great Job!',
          'Final Score' : 'Final Score',
          'Back Home' : 'Back Home',
          'Score' : 'Score',
          'Previous': 'Previous'
        }
      },

      he: {
        translation: {
          "title": "עוזר",
          "Choose a category:": "בחר קטגוריה:",
          "Learn ABC" : "תרגול ה א ב ג",
          "Question" : "שאלה",
          "Submit"  :"שלח", 
          'Great Job!' : 'עבודה מעולה!',
          'Final Score' : 'ציון סופי',
          'Back Home' : 'חזרה לדף הבית',
          'Score' : 'תוצאה',
          'Previous': 'חזרה אחורה'

        }
      }
    },
    lng: "en", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",

    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
